(ns common.schema.entities.risk.permissions
  (:require
   [common.schema.entities.permission-checks :as permission-checks]))

(defn read-permissions?
  [_ctx]
  true)

(defn disable-permissions?
  [ctx]
  (permission-checks/delete-not-allowed! ctx))
